// @flow
import TableSummary from './TableSummary';

export default TableSummary;
